export enum OrderStatus {
  CANCEL = 0,
  WAITING_APPLY = 1,
  WAITING_APPROVE = 2,
  WAITING_DEPLOY = 10,
  PROCESSING = 20,
  PICKING = 30,
  OUT_OF_STOCK = 40,
  ALREADY_SHIPPED = 50,
  SHIPPING_ABNORMAL = 60,
  FINISH = 70,
}

export const OrderStatusLabel: { [key in OrderStatus]: string } = {
  [OrderStatus.CANCEL]: "取消訂單",
  [OrderStatus.WAITING_APPLY]: "待申請",
  [OrderStatus.WAITING_APPROVE]: "待審核",
  [OrderStatus.WAITING_DEPLOY]: "待拋單",
  [OrderStatus.PROCESSING]: "已拋單/待處理",
  [OrderStatus.PICKING]: "撿貨處理中",
  [OrderStatus.OUT_OF_STOCK]: "庫存不足",
  [OrderStatus.ALREADY_SHIPPED]: "配送中",
  [OrderStatus.SHIPPING_ABNORMAL]: "配送異常",
  [OrderStatus.FINISH]: "已送達",
};

/**
 * 依傳入的 OrderStatus key 子集，篩選出對應的下拉選單 options 與 label map
 * @param keys - 要保留的 OrderStatus key 陣列，決定回傳結果只包含哪些狀態
 * @returns Object
 * {
 *    OrderStatusOptions: { value: OrderStatus; label: string }[]; // 下拉選單 options
 *    OrderStatusLabel: Partial<Record<OrderStatus, string>>; // key → label 對照表
 * }
 * 包含篩選後的 OrderStatusOptions(Select options，{ value, label }[]）與 OrderStatusLabel（key → label 對照表）
 */
export const getOrderStatusSubset = (
  keys: OrderStatus[],
): {
  OrderStatusOptions: { value: OrderStatus; label: string }[];
  OrderStatusLabel: Partial<Record<OrderStatus, string>>;
} => {
  const OrderStatusOptions = keys.map((key) => ({ value: key, label: OrderStatusLabel[key] }));
  const filteredOrderStatusLabel = keys.reduce<Partial<Record<OrderStatus, string>>>((acc, key) => {
    acc[key] = OrderStatusLabel[key];
    return acc;
  }, {});
  return { OrderStatusOptions, OrderStatusLabel: filteredOrderStatusLabel };
};
